<script setup>
import SystemFooter from '@/views/layout/SystemFooter'
import ContentLayout from '@/views/layout/ContentLayout'
import TopMenu from '@/views/layout/TopMenu'
import RightFooter from '@/views/layout/RightFooter'
import { useRoute } from 'vue-router'
import { computed } from 'vue'
import { Layout } from 'ant-design-vue';
const ALayout = Layout;
const ALayoutContent = Layout.Content;
const route = useRoute()
let isIndexPage = computed(() => {
  return route.name === 'Index'
})
</script>

<template>
  <a-layout class="layout">
    <TopMenu :class="[isIndexPage ? 'index-page-top-menu' : '']"/>
    <a-layout-content>
      <div :style="{ background: '#fff'}" class="content-style">
        <ContentLayout />
        <RightFooter />
      </div>
    </a-layout-content>
    <!-- <SystemFooter /> -->
  </a-layout>
</template>

<style scoped lang="less">
.content-style {
  /* height: calc(100vh - 70px); */
  height: 100vh;
  overflow: auto;
}

.index-page-top-menu {
  :deep(.ant-layout-header) {
    background: #fff;
  }
}
.layout {
  max-height: 100vh !important;
  /* overflow: hidden; */
}
</style>
